export const data = [
  {
    id: 1,
    title: "איכות",
    desc: ".קבוצת פורסט מתמקדת באיכות ככלי להשגת המטרות של הלקוחות. אנחנו מקפידים על ליווי ברמה הגבוהה ביותר ומבצעים בקפדנות כל פרט כדי להבטיח איכות ברמה הגבוהה ביותר",
  },
  {
    id: 2,
    title: "אמינות",
    desc: "קבוצת פורסט מתחייבת לעמידה בכל התנאים והמחויבות כלפי הלקוחות שלנו. אנו מקפידים למקם את הלקוחות במרכז הפעילות שלנו ולהיות לצידם בכל שאלה או בעיה. קבוצת פורסט תעשה מאמץ רב כדי לספק את הפתרון המתאים ביותר.",
  },
  {
    id: 3,
    title: "מקצועיות",
    desc: "כקבוצת פורסט חשוב לנו להיות מקצועיים בעשייתנו ולכן אנו מציעים לכלל לקוחותינו שירותי ייעוץ מקצועיים ומומחים בתחום הנדל'ן. אנו מעודכנים בכל המדיע הטכני והמקצועי בתחום ומתחייבים לספק מענה מקצועי ומותאם אישית.",
  },
  {
    id: 4,
    title: "שירותיות",
    desc: "קבוצת פורסט מתייחסת ללקוחותיה בכבוד ובנדיבות ומספקים להם שירות ברמה הגבוהה ביותר.אנו מתאימים את השירות שלנו לצרכי הלקוחות ומשקיעים המון מאמץ כדי לספק להם חווית שירות נעימה וטובה.",
  },
  {
    id: 5,
    title: "חדורי מטרה",
    desc: "כסוכנים בקבוצת פורסט, אנו מזדהים עם ערכי החברה ומאמינים בסיפור המצליח שלה. העבודה שלנו מאפשרת לנו לסייע לאנשים למצוא את הנכס המתאים להם, לעזור לסגור עסקאות ולסייע בהגשמת חלומותיהם. המשימה המשמעותית שלנו מעניקה לנו תחושת סיפוק והצלחה",
  },
];

export const companyTestimonialData = [
  {
    id: 1,
    name: "מלכיאל חזן",
    desc: "קבוצת פורסט היקרים אני חייב להגיד שאחרי בדיקה מול הרבה מתווכים-ללא מענה מקצועי מספיק, השירות שלכם היה שירות מעולה ואני מרוצה עד היום מהעסקה שעשיתי איתכם,   חייב להגיד לכם תודה  מכל הלב",
  },
  {
    id: 2,
    name: "דותן קברט",
    desc: "אין ספק שאשכור את שירותיהם שוב פעם, הכי מקצועיים שפגשתי.",
  },
  {
    id: 3,
    name: "מליסאו מוצ'ה",
    desc: "חושבים אך ורק לטובת הלקוח, בחרתי נכון",
  },
  {
    id: 4,
    name: "רותי אלמה",
    desc: "מעבר למקצועיות שלהם, 'פורסט גרופ' תמיד זמינים לכל שאלה, מראים מקצועיות וידע נרחב, בחרתי נכון",
  },
  {
    id: 5,
    name: "חנה טמנו",
    desc: "ברצוני לשבח את העובדים המסורים של משרד תיווך 'פורסט גרופ' על השירות האדיב והמקצועי. אחרי פנייתי אליכם, חזרתם אלי במהרה לטיפול מקצועי ואדיב. עומדים במילה ועושים הכל למען הלקוח",
  },
  {
    id: 6,
    name: "מקונן מוגוס",
    desc: "פורסט גרופ' תותחי על, אמינים וזמינים לכל השאלות, בטוח שאשוב לרכוש את שירותיהם.",
  },
];
